import type { ComponentType, ReactNode, SVGProps } from "react"

import { cn } from "@productlane/lib/src/browser"

import type { ReportingTone } from "./theme"
import { reportingCardClassName, reportingCardLoadingClassName } from "./theme"

interface ReportingKpiCardProps {
	label: string
	value: ReactNode
	isLoading?: boolean
	className?: string
	Icon?: ComponentType<SVGProps<SVGSVGElement>>
	tone?: ReportingTone
	hint?: string
	footer?: ReactNode
}

export const ReportingKpiCard = ({
	label,
	value,
	isLoading,
	className,
	Icon,
	hint,
	footer,
}: ReportingKpiCardProps) => {
	if (isLoading) {
		return (
			<div
				className={cn(
					reportingCardLoadingClassName,
					"relative overflow-hidden px-4 py-3.5",
					className,
				)}
			>
				<div className="mb-2 h-3 w-16 rounded bg-gray-200 dark:bg-gray-700" />
				<div className="h-7 w-12 rounded bg-gray-200 dark:bg-gray-700" />
			</div>
		)
	}

	return (
		<div
			className={cn(
				reportingCardClassName,
				"relative overflow-hidden px-4 py-3.5",
				className,
			)}
		>
			<div className="flex items-center gap-1.5">
				{Icon ? <Icon className="h-3.5 w-3.5 shrink-0 text-tertiary" /> : null}
				<p className="text-xs text-tertiary">{label}</p>
			</div>
			<p className="mt-1 text-2xl font-semibold tracking-tight text-primary">
				{value ?? "—"}
			</p>
			{hint ? <p className="mt-0.5 text-[11px] text-tertiary">{hint}</p> : null}
			{footer ? <div className="mt-2">{footer}</div> : null}
		</div>
	)
}
